import { t } from "i18next";
import { addS3Url } from "./modules";

export const advantages = [
  { id: 1, title: t("payment.benefits.ai_tools") },
  { id: 2, title: t("payment.benefits.additional_sources") },
  {
    id: 3,
    title: t("payment.benefits.skills"),
  },
  { id: 4, title: t("payment.benefits.beginner_lessons") },
  { id: 5, title: t("payment.benefits.guidance") },
];

export const paymentTypes = [
  { id: 1, src: addS3Url("/payment/visa.svg") },
  { id: 2, src: addS3Url("/payment/master-card.svg") },
  // { id: 3, src: addS3Url("/payment/paypal.svg") },
  { id: 4, src: addS3Url("/payment/apay.svg") },
];

export const features = [
  { id: 1, title: t("payment.income_know_how") },
  { id: 2, title: t("payment.lessons") },
  {
    id: 3,
    title: t("payment.personal_coach"),
  },
];

export const reviews = [
  {
    id: 1,
    img: addS3Url("/payment/smiling-sunglasses.png"),
    name: "@atellb",
    title: t("payment.user_reviews.review_1"),
  },
  {
    id: 2,
    img: addS3Url("/payment/smiling-sunglasses.png"),
    name: "@lkleir",
    title: t("payment.user_reviews.review_2"),
  },
  {
    id: 3,
    img: addS3Url("/payment/smiling-sunglasses.png"),
    name: "@anntp",
    title: t("payment.user_reviews.review_3"),
  },
];

export const features2 = [
  { id: 1, title: t("payment.no_degree") },
  { id: 2, title: t("payment.no_university_degree") },
  {
    id: 3,
    title: t("payment.work_at_your_pace"),
  },
];

export const priceList = [
  {
    id: 1,
    icon: addS3Url("/payment/pc.svg"),
    title: t("payment.career_titles.digital_marketing"),
    income: t("payment.career_info.digital_marketing"),
    color: "#6659C4",
  },
  {
    id: 2,
    icon: addS3Url("/payment/pen.svg"),
    title: t("payment.career_titles.content_writer"),
    income: t("payment.career_info.content_writer"),
    color: "#419741",
  },
  {
    id: 3,
    icon: addS3Url("/payment/brush.svg"),
    title: t("payment.career_titles.graphic_designer"),
    income: t("payment.career_info.graphic_designer"),
    color: "#D33078",
  },
];

export const faq = [
  {
    id: 1,
    que: t("payment.faqs.career_freedom_plan"),
    ans: t("payment.faq_answers.career_freedom_plan"),
  },
  {
    id: 2,
    que: t("payment.faqs.commitment_concerns"),
    ans: t("payment.faq_answers.commitment_concerns"),
  },
  {
    id: 3,
    que: t("payment.faqs.technical_skills"),
    ans: t("payment.faq_answers.technical_skills"),
  },
];

export const aiCardData = {
  Copywriting: [
    {
      id: 1,
      image: addS3Url("/aiBots/1.png"),
      title: "ContentComposer",
      desc: "ContentComposer assists in creating engaging and effective content for various platforms, focusing on tone, style, and audience.",
    },
    {
      id: 2,
      image: addS3Url("/aiBots/2.png"),
      title: "CopyCraft",
      desc: "CopyCraft specializes in creating compelling copy for advertising, websites, and marketing materials, focusing on persuasion and clarity.",
    },
    {
      id: 3,
      image: addS3Url("/aiBots/3.png"),
      title: "CreativeCopy",
      desc: "CreativeCopy provides innovative copywriting solutions for branding, social media, and digital campaigns, emphasizing creativity and brand voice.",
    },
  ],
  "Content Writing": [
    {
      id: 1,
      image: addS3Url("/aiBots/1.png"),
      title: "ContentComposer",
      desc: "ContentComposer assists in creating engaging and effective content for various platforms, focusing on tone, style, and audience.",
    },
    {
      id: 4,
      image: addS3Url("/aiBots/4.png"),
      title: "ChatGPT Classic",
      desc: "The latest version of GPT-4 with no additional capabilities",
    },
    {
      id: 5,
      image: addS3Url("/aiBots/5.png"),
      title: "ContentCrafter",
      desc: "ContentCrafter assists in generating creative content ideas, outlines, and offers writing tips for various formats.",
    },
    {
      id: 6,
      image: addS3Url("/aiBots/6.png"),
      title: "EmailEngine",
      desc: "EmailEngine specializes in crafting effective email marketing campaigns, providing templates, and analyzing campaign performance.",
    },
    {
      id: 7,
      image: addS3Url("/aiBots/7.png"),
      title: "ScriptScribe",
      desc: "ScriptScribe offers expert guidance in scriptwriting for films, TV shows, and online videos, focusing on narrative structure and character development.",
    },
  ],
  Inspiration: [
    {
      id: 4,
      image: addS3Url("/aiBots/4.png"),
      title: "ChatGPT Classic",
      desc: "The latest version of GPT-4 with no additional capabilities",
    },
    {
      id: 8,
      image: addS3Url("/aiBots/8.png"),
      title: "SocialSpark",
      desc: "SocialSpark offers creative social media management tips, platform-specific strategies, and engagement techniques.",
    },
    {
      id: 5,
      image: addS3Url("/aiBots/5.png"),
      title: "ContentCrafter",
      desc: "ContentCrafter assists in generating creative content ideas, outlines, and offers writing tips for various formats.",
    },
    {
      id: 9,
      image: addS3Url("/aiBots/9.png"),
      title: "FunBot",
      desc: "FunBot suggests entertainment options, fun facts, and organizes games and quizzes for leisure activities.",
    },
    {
      id: 10,
      image: addS3Url("/aiBots/10.png"),
      title: "BrandBooster",
      desc: "BrandBooster provides branding advice, identifies target demographics, and develops unique branding strategies.",
    },
    {
      id: 11,
      image: addS3Url("/aiBots/11.png"),
      title: "IdeaInnovator",
      desc: "IdeaInnovator specializes in generating creative and innovative ideas for projects, businesses, and personal",
    },
    {
      id: 12,
      image: addS3Url("/aiBots/12.png"),
      title: "BrainstormBuddy",
      desc: "BrainstormBuddy acts as a facilitator in brainstorming sessions, asking critical follow-up questions",
    },
    {
      id: 3,
      image: addS3Url("/aiBots/3.png"),
      title: "CreativeCopy",
      desc: "CreativeCopy provides innovative copywriting solutions for branding, social media, and digital campaigns, emphasizing creativity and brand voice.",
    },
  ],

  Analysis: [
    {
      id: 4,
      image: addS3Url("/aiBots/4.png"),
      title: "ChatGPT Classic",
      desc: "The latest version of GPT-4 with no additional capabilities",
    },
    {
      id: 13,
      image: addS3Url("/aiBots/13.png"),
      title: "MarketMaster",
      desc: "MarketMaster specializes in providing up-to-date digital marketing strategies, analyzing market trends",
    },
    {
      id: 6,
      image: addS3Url("/aiBots/6.png"),
      title: "EmailEngine",
      desc: "EmailEngine specializes in crafting effective email marketing campaigns, providing templates, and analyzing campaign performance.",
    },
    {
      id: 14,
      image: addS3Url("/aiBots/14.png"),
      title: "SEOExpert",
      desc: "SEOExpert offers in-depth SEO analysis, keyword research tips, and optimization strategies for websites.",
    },
  ],
  "Digital Marketing": [
    {
      id: 4,
      image: addS3Url("/aiBots/4.png"),
      title: "ChatGPT Classic",
      desc: "The latest version of GPT-4 with no additional capabilities",
    },
    {
      id: 13,
      image: addS3Url("/aiBots/13.png"),
      title: "MarketMaster",
      desc: "MarketMaster specializes in providing up-to-date digital marketing strategies, analyzing market trends",
    },
    {
      id: 8,
      image: addS3Url("/aiBots/8.png"),
      title: "SocialSpark",
      desc: "SocialSpark offers creative social media management tips, platform-specific strategies, and engagement techniques.",
    },
    {
      id: 6,
      image: addS3Url("/aiBots/6.png"),
      title: "EmailEngine",
      desc: "EmailEngine specializes in crafting effective email marketing campaigns, providing templates, and analyzing campaign performance.",
    },
    {
      id: 14,
      image: addS3Url("/aiBots/14.png"),
      title: "SEOExpert",
      desc: "SEOExpert offers in-depth SEO analysis, keyword research tips, and optimization strategies for websites.",
    },
    {
      id: 2,
      image: addS3Url("/aiBots/2.png"),
      title: "CopyCraft",
      desc: "CopyCraft specializes in creating compelling copy for advertising, websites, and marketing materials, focusing on persuasion and clarity.",
    },
    {
      id: 3,
      image: addS3Url("/aiBots/3.png"),
      title: "CreativeCopy",
      desc: "CreativeCopy provides innovative copywriting solutions for branding, social media, and digital campaigns, emphasizing creativity and brand voice.",
    },
  ],
  Popular: [
    {
      id: 4,
      image: addS3Url("/aiBots/4.png"),
      title: "ChatGPT Classic",
      desc: "The latest version of GPT-4 with no additional capabilities",
    },
    {
      id: 13,
      image: addS3Url("/aiBots/13.png"),
      title: "MarketMaster",
      desc: "MarketMaster specializes in providing up-to-date digital marketing strategies, analyzing market trends",
    },
    {
      id: 15,
      image: addS3Url("/aiBots/15.png"),
      title: "ProductivityPro",
      desc: "ProductivityPro helps in organizing tasks, time management, and enhancing personal and professional productivity.",
    },
    {
      id: 5,
      image: addS3Url("/aiBots/5.png"),
      title: "ContentCrafter",
      desc: "ContentCrafter assists in generating creative content ideas, outlines, and offers writing tips for various formats.",
    },
    {
      id: 14,
      image: addS3Url("/aiBots/14.png"),
      title: "SEOExpert",
      desc: "SEOExpert offers in-depth SEO analysis, keyword research tips, and optimization strategies for websites.",
    },
    {
      id: 11,
      image: addS3Url("/aiBots/11.png"),
      title: "IdeaInnovator",
      desc: "IdeaInnovator specializes in generating creative and innovative ideas for projects, businesses, and personal",
    },
    {
      id: 12,
      image: addS3Url("/aiBots/12.png"),
      title: "BrainstormBuddy",
      desc: "BrainstormBuddy acts as a facilitator in brainstorming sessions, asking critical follow-up questions",
    },
    {
      id: 16,
      image: addS3Url("/aiBots/16.png"),
      title: "CareerCoach",
      desc: "CareerCoach provides career advice, resume tips, and interview preparation techniques for professional growth.",
    },
  ],
  Wellness: [
    {
      id: 15,
      image: addS3Url("/aiBots/15.png"),
      title: "ProductivityPro",
      desc: "ProductivityPro helps in organizing tasks, time management, and enhancing personal and professional productivity.",
    },
    {
      id: 17,
      image: addS3Url("/aiBots/17.png"),
      title: "HealthHelper",
      desc: "HealthHelper offers tips on maintaining a healthy lifestyle, including diet, exercise, and mental wellness.",
    },
    {
      id: 18,
      image: addS3Url("/aiBots/18.png"),
      title: "RecipeRadar",
      desc: "RecipeRadar suggests delicious recipes based on ingredients users have, dietary preferences, and cooking skills.",
    },
  ],
  Personal: [
    {
      id: 15,
      image: addS3Url("/aiBots/15.png"),
      title: "ProductivityPro",
      desc: "ProductivityPro helps in organizing tasks, time management, and enhancing personal and professional productivity.",
    },
    {
      id: 11,
      image: addS3Url("/aiBots/11.png"),
      title: "IdeaInnovator",
      desc: "IdeaInnovator specializes in generating creative and innovative ideas for projects, businesses, and personal",
    },
    {
      id: 12,
      image: addS3Url("/aiBots/12.png"),
      title: "BrainstormBuddy",
      desc: "BrainstormBuddy acts as a facilitator in brainstorming sessions, asking critical follow-up questions",
    },
    {
      id: 17,
      image: addS3Url("/aiBots/17.png"),
      title: "HealthHelper",
      desc: "HealthHelper offers tips on maintaining a healthy lifestyle, including diet, exercise, and mental wellness.",
    },
    {
      id: 19,
      image: addS3Url("/aiBots/19.png"),
      title: "FinanceGuru",
      desc: "FinanceGuru provides financial advice, budgeting tips, and investment strategies for personal finance management.",
    },
    {
      id: 20,
      image: addS3Url("/aiBots/20.png"),
      title: "TechTutor",
      desc: "TechTutor guides users through technology-related queries, from basic troubleshooting to advanced tech advice.",
    },
    {
      id: 21,
      image: addS3Url("/aiBots/21.png"),
      title: "LanguageLearner",
      desc: "LanguageLearner assists in learning new languages, offering practice exercises, grammar tips, and cultural insights.",
    },
    {
      id: 16,
      image: addS3Url("/aiBots/16.png"),
      title: "CareerCoach",
      desc: "CareerCoach provides career advice, resume tips, and interview preparation techniques for professional growth.",
    },
    {
      id: 18,
      image: addS3Url("/aiBots/18.png"),
      title: "RecipeRadar",
      desc: "RecipeRadar suggests delicious recipes based on ingredients users have, dietary preferences, and cooking skills.",
    },
  ],
  Leisure: [
    {
      id: 9,
      image: addS3Url("/aiBots/9.png"),
      title: "FunBot",
      desc: "FunBot suggests entertainment options, fun facts, and organizes games and quizzes for leisure activities.",
    },
    {
      id: 21,
      image: addS3Url("/aiBots/21.png"),
      title: "LanguageLearner",
      desc: "LanguageLearner assists in learning new languages, offering practice exercises, grammar tips, and cultural insights.",
    },
    {
      id: 18,
      image: addS3Url("/aiBots/18.png"),
      title: "RecipeRadar",
      desc: "RecipeRadar suggests delicious recipes based on ingredients users have, dietary preferences, and cooking skills.",
    },
  ],
  Translation: [
    {
      id: 22,
      image: addS3Url("/aiBots/22.png"),
      title: "TranslateTalent",
      desc: "TranslateTalent aids in translating content across multiple languages, focusing on accuracy and cultural",
    },
  ],
};
